/**
 * Created by zuozhuo on 2018/1/25.
 */
import history from "../router/history";
import urlUtils from "url";
import querystring from "querystring";
import Nzh from "nzh";
import moment from "moment";
import "moment/locale/zh-cn";

import * as consts from "../consts/consts";
import config from "../consts/config";
import classnames from "classnames";
import SHA1 from "./sha1";
import { Base64 } from "js-base64";
import {
  noop,
  delay,
  defer,
  debounce,
  throttle,
  isEqual,
  isEmpty,
  template
} from "lodash";
import foStorage from "./foStorage";
import { isObservable, toJS, isObservableArray } from "mobx";
import { Toast, Modal } from "foui";
import Cookies from "js-cookie";
import { URL_INDEX } from "../consts/consts";
import { INVITE_MEMBER_ID } from "../consts/consts";
import {
  HTTP_CODE_SUCCESS,
  HTTP_CODE_COIN_NOT_ENOUGH,
  STATIC_FACE_IMAGES_DOMAIN
} from "../consts/consts";
import bridge from "./bridge/bridge";
import bridgeApis from "./bridge/bridgeApis";
import { URL_HASH_KEYS, MEMBER_VIP_LEVEL_LABEL } from "../consts/consts";
import BxToast from "../foui/src/toast";

const APP_UA_REGEX = /\s+(FoApp)\/([\d\.]*)\s*\(([^\)]*)\)/i;

moment.locale("zh-cn");

function getAppUAInfo(ua = window.navigator.userAgent) {
  const matches = ua.match(APP_UA_REGEX);
  if (matches) {
    return {
      isApp: true,
      name: matches[1],
      version: matches[2],
      platform: matches[3]
    };
  }
  return {
    isApp: false
  };
}

const APP_UA_INFO = getAppUAInfo();

function isDebug() {
  return process.env.NODE_ENV !== "production";
}

function isSameUrl(url) {
  const keys = [URL_HASH_KEYS.JS_SDK_HASH, URL_HASH_KEYS.HTML_CACHE_HASH];
  return (
    removeUrlQuery(url, keys) === removeUrlQuery(getCurrentPageUrl(), keys)
  );
}

function navigateUrl(action = "push", url, query = {}) {
  let _url = url;

  const meta = getUrlMeta(url);
  if (meta.isAbsolute) {
    if (meta.isSelfHost) {
      _url = meta.fullPath;
    } else {
      if (action === "push") {
        return (window.location.href = _url);
      } else {
        return window.location.replace(_url);
      }
    }
  }

  if (isSameUrl(url)) {
    action = "replace";
  }

  if (action === "push") {
    return history.push(appendUrlQuery(_url, query));
  } else {
    return history.replace(appendUrlQuery(_url, query));
  }
}

function goBack() {
  // if (isIOS() && isWeiXin()) {
  //   window.location.href = document.referrer;
  //   return;
  // }

  return history.go(-1);
}

/**
 * push到某个路由地址
 *
 * @param {string} url - 地址url
 * @param query
 * @returns {*}
 */
function pushUrl(url, query = {}) {
  return navigateUrl("push", url, query);
}

/**
 * replace 到某个路由地址
 *
 * @param {string} url - 地址url
 * @param query
 * @returns {*}
 */
function replaceUrl(url, query = {}) {
  return navigateUrl("replace", url, query);
}

function appendUrlQuery(url, query = {}) {
  const parsedUrl = urlUtils.parse(url);
  const queryStringInUrl = parsedUrl.query || "";
  const combinedQuery = querystring.stringify({
    ...querystring.parse(queryStringInUrl),
    ...query
  });
  parsedUrl.search = combinedQuery ? `?${combinedQuery}` : "";
  return parsedUrl.format();
}

function removeUrlQuery(url, keys = []) {
  const parsedUrl = urlUtils.parse(url);
  const queryStringInUrl = parsedUrl.query || "";

  if (queryStringInUrl) {
    const queryJson = querystring.parse(queryStringInUrl);
    [].concat(keys).forEach(key => {
      delete queryJson[key];
    });

    if (isEmpty(queryJson)) {
      parsedUrl.search = "";
    } else {
      parsedUrl.search = `?${querystring.stringify(queryJson)}`;
    }
  } else {
    parsedUrl.search = "";
  }

  return parsedUrl.format();
}

function getUrlQuery(url = window.location.href) {
  return querystring.parse(urlUtils.parse(url).query);
}

function convertNumberToChinese(num) {
  const nzhcn = Nzh.cn; // 使用简体中文,  另外有 Nzh.hk -- 繁体中文
  return nzhcn.encodeS(num);
}

// 在独立组件中获取 match,location和history
// https://stackoverflow.com/questions/42594804/how-to-access-history-object-outside-route-in-react-router-v4
// { match: match, location: location, history: history, staticContext: staticContext }
function getRouteParams(props) {
  return props.match.params;
}

/**
 * 用户是否登录
 *
 * @returns {boolean}
 */
function isLogin() {
  const token = foStorage.getItem(foStorage.KEYS.token);
  if (!token) {
    // 这里不要清空用户localStorage, 会导致 weixinKey 清空后面死循环
    // clearUserLoginData();
    return false;
  }
  return true;
}

function getCurrentPageUrl() {
  return (
    window.location.pathname + window.location.search + window.location.hash
  );
}

function getLoginUrl(return_url, extra_query = {}) {
  return_url = return_url || consts.URL_INDEX;
  return appendUrlQuery(consts.URL_LOGIN, {
    return_url,
    ...extra_query
  });
}

function getPerfectInfoUrl(return_url, extra_query = {}) {
  return_url = return_url || consts.URL_INDEX;
  return appendUrlQuery(consts.url_perfect_info, {
    return_url,
    ...extra_query
  });
}

function getSelfHost() {
  return window.location.protocol + "//" + window.location.host;
}

function getUrlMeta(_url) {
  const urlModel = urlUtils.parse(_url);
  const isSelfHost = urlModel.host === window.location.host;

  // 一定要注意search和hash可能为null
  const fullPath =
    urlModel.pathname + (urlModel.search || "") + (urlModel.hash || "");
  const isAbsolute = !!urlModel.protocol;
  return {
    isSelfHost,
    fullPath,
    isAbsolute,
    urlModel
  };
}

let loginCallbackHandler = null;

function loginRequired(options = {}) {
  const {
    callback = () => {},
    returnUrl = getCurrentPageUrl(),
    autoCallback = false
  } = options;
  const _isLogin = isLogin();
  if (!_isLogin) {
    if (autoCallback) {
      loginCallbackHandler = callback;
    }
    // 因为 redirectToLogin 暂时采用强刷方式, 所以 loginCallbackHandler 暂时无法使用
    redirectToLogin(returnUrl);
  } else {
    callback();
  }
}

function callLoginCallback() {
  if (loginCallbackHandler) {
    loginCallbackHandler();
  }
  loginCallbackHandler = null;
}

function isAtLoginPage() {
  const _isAtLoginPage =
    window.location.pathname === consts.URL_LOGIN ||
    window.location.pathname === consts.URL_LOGIN + "/";
  return _isAtLoginPage;
}

function isAbsoluteUrl(url) {
  return /^[a-z][a-z0-9+.-]*:/.test(url);
}

function ensureAbsoluteUrl(url) {
  if (isAbsoluteUrl(url)) {
    return url;
  }
  const host = getSelfHost();
  return host + url;
}

function isLocalHost(hostname) {
  if (hostname === "localhost") {
    return true;
  }
  if (hostname === "127.0.0.1") {
    return true;
  }
  if (hostname === "0.0.0.0") {
    return true;
  }
  if (/^192\.168\.\d+\.\d+$/gi.test(hostname)) {
    return true;
  }

  return false;
}

/*
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4005e0c030dd89c4&redirect_uri=https%3A%2F%2Ftestm.diandianworks.cn%2Flogin%3Freturn_url%3D%252Ftest%252F9%253Fa%253D1&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect
 */
function getWeixinAuthUrl(
  returnUrl = consts.URL_INDEX,
  options = {},
  test_code = "",
  extraQuery = {}
) {
  const _host = getSelfHost(); // "https://localhost:3000"
  let _loginUrl =
    _host +
    getLoginUrl(returnUrl, {
      ...extraQuery,
      source: getOrganizationWechatAppId()
    });
  if (isLocalHost(window.location.hostname)) {
    _loginUrl = appendUrlQuery(_loginUrl, {
      pass_down_host: window.location.host
    });
  }

  // 是否直接跳转 instantlyRedirect: 1 授权成功后直接从login页面跳转到returnUrl
  if (options.instantlyRedirect) {
    _loginUrl = appendUrlQuery(_loginUrl, {
      instantlyRedirect: options.instantlyRedirect
    });
  }

  if (options.wxLogin) {
    _loginUrl = appendUrlQuery(_loginUrl, {
      wxLogin: options.wxLogin
    });
  }

  // 现在回跳地址直接到服务器api地址, 给定redirect,回跳到前端地址
  const wx_redirect_url = appendUrlQuery(config.wx_code_auth_api, {
    redirect: _loginUrl
  });

  // 如果传了测试code, 那么直接用测试code进行登录
  if (test_code) {
    const testCodeAuthUrl = appendUrlQuery(wx_redirect_url, {
      code: test_code
    });
    return testCodeAuthUrl;
  }

  const appid = options.appid || getWechatAppId() || config.wx_appid;
  const redirect_uri = options.redirect_uri || wx_redirect_url;
  const response_type = options.response_type || "code";
  const scope = options.scope || "snsapi_userinfo";
  const state = options.state || "STATE";

  const stringifiedQuery = querystring.stringify({
    appid,
    redirect_uri,
    response_type,
    scope,
    state
  });
  return `https://open.weixin.qq.com/connect/oauth2/authorize?${stringifiedQuery}#wechat_redirect`;
}

function isChineseChar(str) {
  return /[^u4e00-u9fa5]/.test(str);
}

function getScrollTop(domElement) {
  if (
    domElement === window ||
    domElement === document ||
    domElement === document.body
  ) {
    return document.body.scrollTop;
  }
  return domElement.scrollTop;
}

function getScrollBottom(domElement) {
  if (
    domElement === window ||
    domElement === document ||
    domElement === document.body
  ) {
    return (
      document.body.scrollHeight - window.innerHeight - document.body.scrollTop
    );
  }
  return (
    domElement.scrollHeight - domElement.clientHeight - domElement.scrollTop
  );
}

function getScrollLayoutBody() {
  const layoutBody = document.querySelector(".appLayout-body");
  return layoutBody;
}

function scrollToTop() {
  // html标签滚动到顶部
  document.documentElement.scrollTop = 0;
  const layoutBody = getScrollLayoutBody();
  // 布局容器滚动到顶部
  if (layoutBody) {
    layoutBody.scrollTop = 0;
  }
}

function getScrollIntoViewTopValue(element, container, offset = 0) {
  container = container || getScrollLayoutBody();
  return container.scrollTop + element.getBoundingClientRect().top + offset;
}

function scrollIntoView(element, container, offset = 0) {
  container = container || getScrollLayoutBody();
  container.scrollTop = getScrollIntoViewTopValue(element, container, offset);
}

function removeSpaces(str) {
  return str.replace(/\s+/gi, "");
}

function appendScript(src) {
  const js = document.createElement("script");
  js.src = src;
  js.async = true;
  document.head.appendChild(js);
}

function isPc() {
  const system = {
    win: false,
    mac: false,
    x11: false
  };
  const p = navigator.platform;
  system.win = p.indexOf("Win") === 0;
  system.mac = p.indexOf("Mac") === 0;
  system.x11 = p === "X11" || p.indexOf("Linux") === 0;
  if (system.win || system.mac || system.x11) {
    if (
      !/iphone/i.test(navigator.userAgent) &&
      !/android/i.test(navigator.userAgent)
    ) {
      return true;
    }
  }
  return false;
}

function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase();
  return /MicroMessenger/i.test(ua);
}

function isDingTalk() {
  const ua = window.navigator.userAgent.toLowerCase();
  return /DingTalk/i.test(ua);
}

function isIOS(userAgent = navigator.userAgent) {
  return userAgent.match(/ipad|iphone|ipod/i);
}

function isAndroid(userAgent = navigator.userAgent) {
  return userAgent.match(/android/i);
}

function isFoApp() {
  return APP_UA_INFO.isApp;
}

function isApplet() {
  const ua = window.navigator.userAgent.toLowerCase();
  return /miniProgram/i.test(ua);
}

function wxJSBridgeReady(cb) {
  if (-1 !== navigator.userAgent.toLowerCase().indexOf("micromessenger")) {
    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
      document.addEventListener("WeixinJSBridgeReady", cb, false);
    } else {
      cb();
    }
  } else {
    cb();
  }
}

const _isMini = new Promise((resolve, reject) => {
  wxJSBridgeReady(resolve);
}).then(() => {
  return window.__wxjs_environment === "miniprogram";
});
function isMiniProgram() {
  return _isMini;
}

function clearUserLoginData() {
  foStorage.clearUserData();
}

function formatMoney(price) {
  return parseFloat(price).toFixed(2);
}

/**
 * 时间秒数格式化
 * 时间戳 格式化为 时分秒（00:00:00）
 * @param s 时间戳（单位：秒）
 * @param fractionalDigits 最后一秒的精度
 * @returns {*} 格式化后的时分秒
 */
function secondsToTime(s, fractionalDigits = 0) {
  var t;
  s = parseFloat(s);
  if (s > -1) {
    var hour = Math.floor(s / 3600);
    var min = Math.floor(s / 60) % 60;
    var sec = parseFloat(Math.floor(s % 60).toFixed(fractionalDigits));

    if (hour < 10) {
      t = "0" + hour + ":";
    } else {
      t = hour + ":";
    }

    if (hour <= 0) {
      t = "";
    }

    if (min < 10) {
      t += "0";
    }
    t += min + ":";
    if (sec < 10) {
      t += "0";
    }
    t += sec + "";
  }
  return t;
}

/**
 * 时间转为秒
 * 时分秒（00:00:00） 转为 时间戳
 * @param timeStr 时间(00:00:00)
 * @returns {string} 时间戳（单位：秒）
 */
function timeToSeconds(timeStr) {
  var s = 0;

  var hour = timeStr.split(":")[0];
  var min = timeStr.split(":")[1];
  var sec = timeStr.split(":")[2];

  s = Number(hour * 3600) + Number(min * 60) + Number(sec);

  return s;
}

function timestampToTime(timestamp) {
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = date.getDate() + " ";
  var h = date.getHours() + ":";
  var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return Y + M + D + h + m;
}

function xorStrings(key, input) {
  if (typeof input !== "string") {
    input = JSON.stringify(input);
  }
  let output = "";
  for (let i = 0; i < input.length; i++) {
    const c = input.charCodeAt(i);
    const k = key.charCodeAt(i % key.length);
    output += String.fromCharCode(c ^ k);
  }
  return output;
}

function sha1Encode(str) {
  const shaObj = new SHA1("SHA-1", "TEXT");
  shaObj.update(str);
  return shaObj.getHash("HEX");
}

const base64Encode = Base64.encode;
const base64Decode = Base64.decode;

function ensurePlainJS(data) {
  if (isObservable(data)) {
    return toJS(data);
  }
  return data;
}

function ensureJSON(json) {
  if (typeof json === "string") {
    return JSON.parse(json);
  }
  return json;
}

function isArray(obj) {
  if (isObservableArray(obj)) {
    return true;
  }
  return Array.isArray(obj);
}

function alert(msg, title = "提示") {
  return Modal.alert(title, msg);
}

function getDayAgo(time) {
  return moment(time)
    .startOf()
    .fromNow();
}

function getDayMonth(time) {
  return moment(time).format("MMMDo HH:mm");
}

function confirm({
  title = "提示",
  content = "",
  confirmText = "确认",
  cancelText = "取消"
} = {}) {
  const platform = isAndroid() ? "android" : "ios";

  return new Promise((resolved, rejected) => {
    Modal.alert(
      title,
      content,
      [
        { text: cancelText, onPress: rejected || noop },
        { text: confirmText, onPress: resolved }
      ],
      platform
    );
  });
}

function prompt({
  title = "提示",
  description = "",
  type = "default",
  placeholder = "",
  defaultValue = ""
} = {}) {
  const platform = isAndroid() ? "android" : "ios";

  return new Promise((resolved, rejected) => {
    Modal.prompt(
      title,
      description,
      [
        { text: "取消", onPress: rejected || noop },
        { text: "确认", onPress: resolved }
      ],
      type,
      defaultValue,
      placeholder,
      platform
    );
  });
}

function callNativeLogin(goBackOnCancel = true) {
  bridgeApis.presentLoginDialog().then(res => {
    const { status, response } = res;
    /*
    status为0 response: { msg: "登录成功" }
    status为1 response: 服务器的整个返回结果
    status为2 response: { msg: "取消登录" }
     */

    const statusInt = +status;

    // status: 0 成功 1 失败 2 取消
    if (statusInt === 0) {
      window.location.reload();
    } else if (statusInt === 2) {
      goBackOnCancel && goBack();
    }
  });
}

function getWeixinAuthKey() {
  return foStorage.getItem(foStorage.KEYS.wxAuthKey) || "";
}

function redirectToWxLogin(returnUrl) {
  let needGoToLogin = false;
  if (isFoApp()) {
    needGoToLogin = !isLogin();
  } else {
    needGoToLogin = !isLogin() && !getWeixinAuthKey();
  }

  if (!needGoToLogin) {
    return false;
  }

  returnUrl = returnUrl || getCurrentPageUrl();

  redirectToLogin(returnUrl, {
    query: {
      wxLogin: true
    }
  });
  return true;
}

function redirectToLogin(returnUrl, { push = true, query = {} } = {}) {
  // 如果在App内,弹出登录窗口
  if (isFoApp()) {
    const token = foStorage.getItem(foStorage.KEYS.token);
    if (token) {
      // 如果本地已经有token, 那么应该是token已经失效了, 通知客户端做相应处理
      bridgeApis.tokenHasExpired({ token });
      return;
    }

    /** 判断是否存在presentLoginDialog bridge方法
    const app_info = APP_UA_INFO;
    const version = app_info.version;
    const versionAry = version.split(".");
    const a = +versionAry[0];
    const b = +versionAry[1];
    const c = +(versionAry[2] || 0);

    // 小于3.2.3 直接提示
    if (a < 3 || (a === 3 && b < 2) || (a === 3 && b === 2 && c < 3)) {
      Toast.info("请先登录!");
      return;
    }
     **/

    // 在ajax和loginRequired方法中, push是为true的, 因为要push一个新的login页
    // 在CustomRoute的loginRequired是先push了一个null页面, push是为false的, 必须能goBack
    const goBackOnCancel = !push;
    callNativeLogin(goBackOnCancel);
    return;
  }
  // 已经在登录页, 那么不处理
  if (isAtLoginPage()) {
    return;
  }

  clearUserLoginData();

  returnUrl = returnUrl || getCurrentPageUrl();

  const loginUrl = getLoginUrl(returnUrl, query);

  setTimeout(() => {
    // 去登录页强刷, 避免store数据残留
    if (push) {
      window.location.href = loginUrl;
    } else {
      window.location.replace(loginUrl);
    }
  }, 0);
}

function redirectToPerfectInfo(returnUrl, { push = true, query = {} } = {}) {
  returnUrl = returnUrl || getCurrentPageUrl();

  const PerfectInfoUrl = getPerfectInfoUrl(returnUrl, query);

  setTimeout(() => {
    // 去登录页强刷, 避免store数据残留
    if (push) {
      window.location.href = PerfectInfoUrl;
    } else {
      window.location.replace(PerfectInfoUrl);
    }
  }, 0);
}

function doLogout(returnUrl = URL_INDEX) {
  clearUserLoginData();
  localStorage.clear();
  window.location.replace(returnUrl);
}

function getInviteMemberId() {
  return foStorage.getItem(foStorage.KEYS.inviteMemberId) || 0;
}

function setInviteMemberId() {
  const inviteId = getUrlQuery()[INVITE_MEMBER_ID];
  if (inviteId) {
    foStorage.setItem(
      foStorage.KEYS.inviteMemberId,
      inviteId,
      new Date().getTime() + 24 * 3600 * 1000
    );
  }
}

function clearInviteMemberId() {
  foStorage.removeItem(foStorage.KEYS.inviteMemberId);
}

function isApiCodeEquals(data, code) {
  return !!(data && parseInt(data.code, 10) === code);
}

function isApiCodeSuccess(data) {
  return isApiCodeEquals(data, HTTP_CODE_SUCCESS);
}

function isApiCodeCoinNotEnough(data) {
  return isApiCodeEquals(data, HTTP_CODE_COIN_NOT_ENOUGH);
}

function ellipsisText(str, len) {
  if (str.length > len) {
    return str.slice(0, len) + "...";
  }
  return str;
}

function escapeCommmentText(comment) {
  let content;

  try {
    content = decodeURIComponent(comment);
  } catch (e) {
    content = comment;
  }

  return content
    .replace(/\n/g, "<br />")
    .replace(/@鼓掌@/g, "#表情[guzhang.png]")
    .replace(/#表情\[(\w+\.(jpg|gif|jpeg|png|pneg))\]/gi, (imageName, $1) => {
      const url = getFaceImageUrl($1);

      return `<img width="100" alt="${$1}" src="${url}" class="face-image" />`;
    });
}

function getFaceImageUrl(imageName) {
  return `${config.emoji_static_domain}${imageName}`;
}

function isAppSchemeUrl(_url) {
  return /^lixin:\/\//gi.test(_url);
}

function getLevelLable(level) {
  return MEMBER_VIP_LEVEL_LABEL[level];
}

function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
}

function isDebugMode() {
  const hasDebugModeKeyInQuery = !!getUrlQuery()["__fo_debug_mode__"];
  return config.debugMode || hasDebugModeKeyInQuery;
}

function domContains(root, n) {
  let node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

function domParentIs(dom, parentTagName) {
  let node = dom;
  while (node) {
    if (
      node &&
      node.tagName &&
      node.tagName.toUpperCase() === parentTagName.toUpperCase()
    ) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

function iOSVersion() {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
    const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);

    if (v && v.length >= 3) {
      const v1 = parseInt(v[1], 10);
      const v2 = parseInt(v[2], 10);
      const v3 = parseInt(v[3] || 0, 10);
      return `${v1}.${v2}.${v3}`;
    }
  }
  return null;
}

/**
 * 安全执行表达式
 * @param expression 要执行的表达式
 * @param data 表达式里面用到的数据
 * @returns {*} 表达式结果
 * @example
 * execExpression("a > 1", { a: 2 }) // true
 */
function execExpression(expression, data) {
  return Function(
    "obj",
    `obj || (obj = {});with (obj) {return (${expression});}`
  ).call(undefined, data);
}

/**
 * 每三位默认加,格式化
 * @param {string|number} x
 * @return {string}
 */
function addCommas(x) {
  if (isNaN(x)) {
    return "-";
  }
  x = (x + "").split(".");
  return (
    x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") +
    (x.length > 1 ? "." + x[1] : "")
  );
}
// 截断字符串
function truncationStr(str, count) {
  str = str + "";
  return str.length > count ? str.slice(0, count - 1) + "..." : str;
}

/**
 * 获取指定的url查询参数值
 * @param {string} pname 参数名称
 * @param {string} purl url地址，默认为当前url地址
 */
function getParameterByName(pname, purl) {
  let name = pname;
  let url = purl;

  if (!url) url = window.location.href;

  name = name.replace(/[[\]]/g, "\\$&");

  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return "";

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
}

function getOrganizationWechatAppId() {
  return (
    localStorage.getItem("organization_wechat_app_id") ||
    getParameterByName("source")
  );
}

function getWechatAppId() {
  return localStorage.getItem("wechat_app_id") || getParameterByName("app_id");
}

export default {
  redirectToPerfectInfo,
  getPerfectInfoUrl,
  domContains,
  domParentIs,
  xorStrings,
  sha1Encode,
  base64Encode,
  base64Decode,
  formatMoney,
  secondsToTime,
  timeToSeconds,
  timestampToTime,
  isDebug,
  pushUrl,
  replaceUrl,
  goBack,
  isLogin,
  getLoginUrl,
  isAtLoginPage,
  clearUserLoginData,
  appendUrlQuery,
  removeUrlQuery,
  isAbsoluteUrl,
  ensureAbsoluteUrl,
  getWeixinAuthUrl,
  isLocalHost,
  getUrlQuery,
  getRouteParams,
  isChineseChar,
  getScrollBottom,
  getScrollTop,
  removeSpaces,
  appendScript,
  isPc,
  isWeiXin,
  isDingTalk,
  isIOS,
  isAndroid,
  isFoApp,
  isApplet,
  isMiniProgram,
  classnames,
  noop,
  delay,
  isEqual,
  defer,
  debounce,
  throttle,
  ensurePlainJS,
  ensureJSON,
  loginRequired,
  callLoginCallback,
  toast: Toast,
  convertNumberToChinese,
  // https://github.com/js-cookie/js-cookie
  // set get remove
  cookies: Cookies,
  moment: moment,
  getCurrentPageUrl,
  getAppUAInfo,
  APP_UA_INFO,
  alert,
  getDayAgo,
  confirm,
  callNativeLogin,
  redirectToLogin,
  redirectToWxLogin,
  doLogout,
  getInviteMemberId,
  setInviteMemberId,
  clearInviteMemberId,
  isApiCodeEquals,
  isApiCodeSuccess,
  isApiCodeCoinNotEnough,
  getDayMonth,
  getSelfHost,
  getUrlMeta,
  ellipsisText,
  getFaceImageUrl,
  scrollToTop,
  escapeCommmentText,
  isAppSchemeUrl,
  getLevelLable,
  copyToClipboard,
  isArray,
  isDebugMode,
  getWeixinAuthKey,
  prompt,
  scrollIntoView,
  getScrollIntoViewTopValue,
  iOSVersion,
  execExpression,
  addCommas,
  truncationStr,
  getParameterByName,
  updateQueryStringParameter,
  getOrganizationWechatAppId,
  getWechatAppId
};



// WEBPACK FOOTER //
// ./src/utils/utils.js